import React, { useState } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useLogoutMutation } from '../modules/auth/authApi';
import BaseModal from '../ui-components/BaseModal';
import Footer from '../ui-components/Footer';
import Header from '../ui-components/Header';
import Sidebar from '../ui-components/Sidebar';
import { useAppDispatch } from '../hooks';
import { logout as logoutAction } from '../modules/user/profileSlice';

const DefaultLayout: React.FC = () => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();

  const handleSignout = async () => {
    try {
      await logout().unwrap();
      dispatch(logoutAction());
      localStorage.clear();
      sessionStorage.clear();
      toast.success('You have been logged out successfully.', {
        autoClose: 1500,
        onClose: () => {
          navigate('/');
          window.location.reload();
        },
      });
      setShowLogoutConfirm(false);
    } catch (err) {
      // Error is handled globally in baseQuery
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-neutral-50 dark:bg-neutral-950">
      {/* Mobile overlay backdrop */}
      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setIsMobileSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar
        onRequestLogout={() => setShowLogoutConfirm(true)}
        isMobileOpen={isMobileSidebarOpen}
        onMobileClose={() => setIsMobileSidebarOpen(false)}
      />
      <div className="flex flex-1 min-h-0 flex-col transition-all duration-300 min-w-0">
        <Header
          onRequestLogout={() => setShowLogoutConfirm(true)}
          onMobileMenuOpen={() => setIsMobileSidebarOpen(true)}
        />
        <main
          data-scroll-lock
          className="flex-1 min-h-0 overflow-y-auto bg-neutral-50 dark:bg-neutral-900 custom-scroll"
        >
          <Outlet />
        </main>
        <Footer />
      </div>
      <BaseModal
        modalData={showLogoutConfirm ? { status: '', selectedIds: [] } : null}
        labels={{
          title: 'Confirm Logout',
          content: 'Are you sure you want to logout?',
          confirmLabel: 'Yes',
          cancelLabel: 'No',
        }}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={handleSignout}
      />
    </div>
  );
};

export default DefaultLayout;
